import React, { useMemo } from 'react';
import InfiniteSelect from '../InfiniteSelect';
import ApiService from '../../services/ApiService';

export interface PantoneValue {
  code: string;
  name?: string;
  hex?: string;
}

interface PantoneSelectProps {
  value: PantoneValue | null;
  onSelect: (pantone: PantoneValue | null) => void;
  placeholder?: string;
  minSearchLength?: number;
}

const PantoneSelect: React.FC<PantoneSelectProps> = ({
  value,
  onSelect,
  placeholder = 'Buscar código Pantone...',
  minSearchLength = 0
}) => {
  const mappedValue = useMemo(() => {
    if (!value) return null;
    return {
      id: value.code,
      name: value.name ? `${value.name} (${value.code})` : value.code,
      hex: value.hex,
    };
  }, [value]);

  const fetchPantones = async (limit: number, offset: number, search?: string) => {
    const query = search?.trim() || '';
    if (query.length < minSearchLength) {
      if (minSearchLength > 0) return [];
    }
    try {
      const res = await ApiService.fashion.findAllPantones({ query, limit, offset });
      const list: any[] = Array.isArray(res.data?.content) ? res.data.content : [];
      return list.map((p) => ({
        id: p.code,
        name: p.name ? `${p.name} (${p.code})` : p.code,
        hex: p.hex ?? undefined,
        pantone: { code: p.code, name: p.name, hex: p.hex },
      }));
    } catch (err) {
      console.error('Erro ao buscar pantones:', err);
      return [];
    }
  };

  return (
    <InfiniteSelect
      name="pantone-select"
      placeholder={placeholder}
      mode="readonly"
      allowCreate={false}
      allowDelete={false}
      showSelectedBelow={false}
      value={mappedValue}
      fetchFunction={fetchPantones}
      onSelect={(opt) => {
        if (!opt) {
          onSelect(null);
          return;
        }
        onSelect({
          code: String(opt.id),
          name: opt.pantone?.name,
          hex: opt.hex,
        });
      }}
      getOptionLabel={(opt) => opt.name}
    />
  );
};

export default PantoneSelect;
